// test323
(323 && 0);
